import {
    CONTRACT_LIST_PAGE_LOADED,
    CONTRACT_LIST_NEXT_PAGE_LOADED,
    CONTRACT_LIST_SEARCH_LOADED,
    UPDATE_CONTRACT_SEARCHTERM,
    CONTRACT_LIST_PAGE_UNLOADED,
    UPDATE_FIELD_CONTRACT,
    CONTRACT_CREATE,
    CONTRACT_CREATE_UNLOADED,
    CONTRACT_UPDATE,
    CONTRACT_UPDATE_UNLOADED,
    CONTRACT_DETAIL_LOADED
} from '../constants/actionTypes';
import { PAGESIZE } from '../constants/config'

export default (state = {}, action) => {
    switch (action.type) {
        case CONTRACT_LIST_PAGE_LOADED:
        case CONTRACT_LIST_NEXT_PAGE_LOADED:
        case CONTRACT_LIST_SEARCH_LOADED:
            return {
                ...state,
                contracts: action.payload.contracts,
                totalCount: action.payload.totalCount,
                currentPage: action.currentPage,
                searchTerm: action.searchTerm,
                status: action.status,
                date_from: action.date_from,
                date_to: action.date_to,
                totalPage: Math.ceil(action.payload.totalCount / PAGESIZE)
            };
        case UPDATE_CONTRACT_SEARCHTERM:
        case UPDATE_FIELD_CONTRACT:
            return {
                ...state,
                [action.key]: action.value,
            }
        case CONTRACT_DETAIL_LOADED:
            return {
                ...state,
                contract: action.payload.contract,
            };
        case CONTRACT_LIST_PAGE_UNLOADED:
        case CONTRACT_CREATE_UNLOADED:
        case CONTRACT_UPDATE_UNLOADED:
            return {};
        case CONTRACT_CREATE:
        case CONTRACT_UPDATE:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.error : null,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/contract.js